import {z} from 'zod/v4';
import {Dateish} from '@packages/utilities/zod';

export const FunctionsPreviewRequest = z.object({
  moduleIds: z.array(z.string().min(1)).min(1).max(100),
  siteFunctionsHash: z.string().min(1).max(128).optional(),
});
export type FunctionsPreviewRequest = z.infer<typeof FunctionsPreviewRequest>;

export const FunctionsPreviewResponse = z.discriminatedUnion('status', [
  z.object({
    status: z.literal('ready'),
    previewOrigin: z.string(),
    previewToken: z.string(),
    tokenExpiresAt: Dateish,
    refreshAt: Dateish,
    // Set when the requested site functions generation was no longer in the
    // sandbox catalog and the newest bundle was served instead.
    siteFunctionsGeneration: z.literal('missing').optional(),
  }),
  // None of the authorized modules in this set have a functions bundle.
  z.object({status: z.literal('no-functions')}),
]);
export type FunctionsPreviewResponse = z.infer<typeof FunctionsPreviewResponse>;
